import { render, staticRenderFns } from "./ImprestCard.vue?vue&type=template&id=0e12ccba&scoped=true"
import script from "./ImprestCard.vue?vue&type=script&lang=js"
export * from "./ImprestCard.vue?vue&type=script&lang=js"
import style0 from "./ImprestCard.vue?vue&type=style&index=0&id=0e12ccba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e12ccba",
  null
  
)

export default component.exports